module.exports = __webpack_public_path__ + "img/border-top.7e6a5cb1.svg";